import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "~/atoms/form";
import { Input } from "~/atoms/input";
import { Button } from "~/atoms/button";
import { Trash } from "lucide-react";
import {
  ControlledCombobox,
  type Option,
} from "~/molecules/ControlledCombobox";
import { type DocumentEditFormValues } from "~/hooks/useDocumentEditForm";

interface DocumentLinkFieldProps {
  title: string;
  selectedDocuments: Option[];
  options: Option[];
}

export const DocumentLinkField = ({
  title,
  selectedDocuments,
  options,
}: DocumentLinkFieldProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext<DocumentEditFormValues>();

  return (
    <FormField
      control={control}
      name="linkedDocuments"
      render={({ field }) => {
        const linkedDocuments = field.value ?? [];
        return (
          <FormItem>
            <FormLabel>{title}</FormLabel>
            {selectedDocuments.map(({ value, label }) => (
              <div className="flex gap-2" key={value}>
                <Input value={label} readOnly />
                <Button
                  type="button"
                  onClick={() =>
                    field.onChange(
                      linkedDocuments.filter((c) => c.value !== value),
                    )
                  }
                  variant="ghost"
                  size="icon"
                >
                  <Trash />
                </Button>
              </div>
            ))}
            <FormControl>
              <ControlledCombobox
                value=""
                onChange={(value) => {
                  const opt = options.find((c) => c.value === value);
                  if (opt) field.onChange([...linkedDocuments, opt]);
                }}
                placeholder={t(($) => $.commons.customSelect.selectDocument)}
                options={options}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
